import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import './Polyfills.js';
import './fonts/GoetheFFClan-Bold.ttf';
import './fonts/GoetheFFClan-Book.ttf';

//var axe = require('react-axe');
//axe(React, ReactDOM, 1000);
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
